export type User = {
	id: number;
	firstName: string;
	lastName: string;
	email: string;
	phoneNumber?: string;
	role: string;
	access: string;
	createdAt: Date;
	updatedAt: Date;
	activatedAt: Date | null;
	rejectedAt: Date | null;
	isSuperAdmin: boolean;
	lastConnectionAt: Date | null;
};

export type UserStats = {
	id: number;
	centersCount: number;
	commandsCount: number;
};

export enum UserCenterRole {
	AUDIOPROSTHESIST = "AUDIOPROSTHESIST",
	ASSISTANT = "ASSISTANT",
	OTHER = "OTHER",
}

export enum UserCenterAccess {
	ADMIN = "ADMIN",
	MEMBER = "MEMBER",
}
